import { Mixpanel } from './mixpanelUtil';
import { categoryOrderMap, configureEditorCommands } from './configureEditorCommands';
import { getCookie } from '../../features/home/app_util';

export const storageManager = (uri, projectId) => {
  return {
    type: 'remote',
    stepsBeforeSave: 6,
    fromElement: true,
    contentTypeJson: true,
    storeComponents: true,
    storeStyles: true,
    storeHtml: true,
    storeCss: true,
    headers: {
      'Content-Type': 'application/json',
      'x-project-id': projectId,
      token: `Bearer ${getCookie('token')}`,
    },
    id: 'nocode-',
    urlStore: `${process.env.REACT_APP_BUILDER_ENGINE}${uri}`,
    urlLoad: `${process.env.REACT_APP_BUILDER_ENGINE}${uri}`,
  };
};

export const configureEditor = (
  editor,
  project,
  version,
  versions,
  togglePopover,
  slug,
  togglePreview,
  geditorBuilderOption,
) => {
  const bm = editor.BlockManager;
  let categories = bm.getCategories();
  categories.each((category) => category.set('order', categoryOrderMap[category.id]));

  editor.on('block:drag', function () {
    let i, tabcontent, tablinks, tabPage, blocksPopover, blocksPopoverBtn;
    tabcontent = document.getElementsByClassName('sidebar');
    blocksPopover = document.getElementsByClassName('gjs-pn-views-add-components-container');
    blocksPopoverBtn = document.getElementById('add-components');
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].classList.remove('selected');
    }

    if (blocksPopover.length > 0) {
      blocksPopover[0].classList.remove('show');
      blocksPopover[0].children[0].classList.remove('show');
      blocksPopover[0].classList.add('hide');
      blocksPopover[0].children[0].classList.add('hide');
      if (blocksPopoverBtn.classList.contains('gjs-pn-active')) {
        blocksPopoverBtn.click();
      }
    }

    if (editor.Modal.isOpen()) {
      editor.Modal.close();
    }
  });

  editor.on('component:selected', function () {
    let i, tabcontent, tablinks, tabPage, blocksPopover, blocksPopoverBtn;
    tabcontent = document.getElementsByClassName('sidebar selected');
    blocksPopover = document.getElementsByClassName('gjs-pn-views-add-components-container');
    blocksPopoverBtn = document.getElementById('add-components');
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].classList.remove('selected');
    }

    if (blocksPopover.length > 0) {
      blocksPopover[0].classList.remove('show');
      blocksPopover[0].children[0].classList.remove('show');
      blocksPopover[0].classList.add('hide');
      blocksPopover[0].children[0].classList.add('hide');
      if (blocksPopoverBtn.classList.contains('gjs-pn-active')) {
        blocksPopoverBtn.click();
      }
    }

    // get the selected componnet and its default toolbar
    addVisibilityTblIcon(editor);
    addCodeIcon(editor);

    // Overriding Style Manager Border Radius property label
    styleManagerBorderRadiusLabel();
    /*
     ** Resetting StorageManager isDeleteContent attr to Default
     ** to manage Save/Delete Route of Canvas
     */
    storageManagerAttrReset(editor);
  });

  editor.on('block:drag:stop', (componentModel, blockModel) => {
    openComponentSetting(componentModel, editor);
    if (typeof componentModel !== 'undefined' && !Array.isArray(componentModel)) {
      const modelName = componentModel.getName();
      if (
        modelName &&
        ['Cards', 'Pre-Built Layouts'].includes(modelName) &&
        componentModel.closestType('data-group')
      ) {
        componentModel.addClass('col-12');
      }
      Mixpanel.track(`${modelName} component has been dropped`);
    }
  });

  editor.on('component:add', (componentModel) => {
    if (editor.Modal.isOpen()) {
      editor.Modal.close();
    }
  });

  editor.on('component:drag:end', (componentModel) => {
    const compTrgtName = componentModel.target.getName();
    if (compTrgtName && ['Cards', 'Pre-Built Layouts'].includes(compTrgtName)) {
      if (compTrgtName === 'Data Group') {
        componentModel.target.addClass('col-12');
      } else if (compTrgtName !== 'Data Group') {
        componentModel.target.removeClass('col-12');
      }
    }

    //Check and Reset Visibility Config on a Component when Drag inside canvas
    resetCompVisibilityConfig(componentModel);
  });
  console.log('==> Current version:>>', version, '>> versions:>> ', versions);
  configureEditorCommands(
    editor,
    project,
    version,
    versions,
    togglePopover,
    slug,
    togglePreview,
    geditorBuilderOption,
  );
};

const openComponentSetting = (componentModel, editor) => {
  const openSettingsForComponents = [
    'Collection Form',
    'Link',
    'Button',
    'Data Group',
    'Data List',
    'Data-list',
    'Data Table',
    'Data-table',
    'Embed',
    'Link Box',
    'Add To Collection',
    'Snippet-ref',
    'Snippet',
    'Placeholder-ref',
    'Search Form',
    'Column',
    'Image',
    'Container',
    'Login Form',
    'Signup Form',
    'Change Password Form',
    'Audio',
    'Snipcart: Buy Now',
    'Dynamic Table',
    'File Upload',
    'Child Data Group',
    'Child Data Group (File)',
    'Calendar',
    'Auto Complete Input Container',
    'Time Slot',
    'Custom Segment',
    'User Multiple Role Form',
    'Stripe: Buy Now',
    'Sub Page',
    'Custom Component',
    'Action Submit',
    'Browser Storage Setter',
    'PDF Viewer',
    'OTP Authenticator',
    'OTP Generation Form',
  ];
  const openSetting =
    typeof componentModel !== 'undefined' &&
    !Array.isArray(componentModel) &&
    openSettingsForComponents.includes(componentModel.getName());
  if (openSetting) {
    if (componentModel.getName() === 'Embed') {
      editor.select(componentModel.find('.embed-responsive-item'));
    } else {
      if (componentModel.getName() === 'Column') {
        if (componentModel.find('.dropzone').length) {
          editor.select(componentModel.find('.dropzone'));
        } else {
          editor.select(componentModel);
        }
      } else {
        editor.select(componentModel);
      }
    }
    editor.Commands.run('tlb-trait-setting', { event });
  } else {
    editor.select(componentModel);
  }
};

const styleManagerBorderRadiusLabel = () => {
  let borderRadiusElm = document.querySelector(
    '#gjs-sm-border-radius.gjs-sm-property.gjs-sm-integer.gjs-sm-property__border-radius',
  );
  let borderRadiusSpanElm = borderRadiusElm.querySelector('SPAN');
  borderRadiusSpanElm.style.width = '150%';
  borderRadiusSpanElm.textContent = 'Border Radius (All Sides)';
};

const storageManagerAttrReset = (editor) => {
  const storageManager = editor.Storage;
  const storageOptions = storageManager.getCurrentStorage();
  if (storageOptions.attributes['isDeleteContent']) {
    storageOptions.attributes['isDeleteContent'] = false;
  }
};

export const cleanBlockCategories = () => {
  const blockCategoriesEl = document.querySelector(
    '#BLOCKS > #blocks > div > .gjs-block-categories',
  );
  if (blockCategoriesEl) {
    Array.from(blockCategoriesEl.children).forEach((bc) => {
      const blockCatTitleEl = bc.querySelector('.gjs-title');
      if (
        blockCatTitleEl.textContent.trim() === 'Sections' ||
        blockCatTitleEl.textContent.trim().startsWith('Pre-Built')
      ) {
        bc.remove();
      }
      if (!bc.hasAttribute('style')) {
        bc.style.order = categoryOrderMap[blockCatTitleEl.textContent.trim()];
      }
    });
  }
};

export const changeStyelDisplay = (display, notDisplay) => {
  if (Array.isArray(display)) {
    display.forEach((it) => (it.style.display = 'block'));
  } else {
    display.style.display = 'block';
  }

  if (Array.isArray(notDisplay)) {
    notDisplay.forEach((it) => (it.style.display = 'none'));
  } else {
    notDisplay.style.display = 'none';
  }
};

export const changeActiveInActive = (removeActives) => {
  if (Array.isArray(removeActives)) {
    removeActives.forEach((it) => it.classList.remove('active'));
  } else {
    removeActives.classList.remove('active');
  }
};
function resetCompVisibilityConfig(componentModel) {
  if (componentModel) {
    let selectedComponentAttrs = componentModel.target ? componentModel.target.getAttributes() : '';
    if (selectedComponentAttrs && selectedComponentAttrs.hasOwnProperty('data-vis-condition')) {
      delete selectedComponentAttrs['data-vis-condition'];
      componentModel.target.setAttributes(selectedComponentAttrs);

      let selectedVisConditionJson = componentModel.target.get('data-visibility-json');
      if (selectedVisConditionJson && Object.keys(selectedVisConditionJson).length) {
        componentModel.target.set('data-visibility-json', '');
        componentModel.target.set('visWhenUserStatus', '');
        componentModel.target.set('visWhenCollectionFrom', '');
        componentModel.target.set('visWhenCollectionField', '');
        componentModel.target.set('visWhenCondition', '');
        componentModel.target.set('visWhenCollectionFieldValue', '');
        componentModel.target.set('visWhenCollectionFieldFixedValue', '');
        componentModel.target.set('visWhenBsl', '');
        componentModel.target.set('visWhenBslKey', '');
        componentModel.target.set('visWhenBslFixedValue', '');
        componentModel.target.set('visThenCondition', '');
        componentModel.target.set('visEnvHide', '');
        componentModel.target.set('visThenAddClass', '');
        componentModel.target.set('visThenRemoveClass', '');
      }
    }
  }
}

function addVisibilityTblIcon(editor) {
  const selectedComponent = editor.getSelected();
  let defaultToolbar = selectedComponent.get('toolbar');
  const defaultTlbIconLength = defaultToolbar.length;

  // set your command and icon here
  const visibilityCommandToAdd = 'tlb-custom-compvisibility';
  const visibilityCommandIcon = 'fa fa-eye-slash';

  // check if this command already exists on this component toolbar
  const visibilityCommandExists = defaultToolbar.some(
    (item) => item.command === visibilityCommandToAdd,
  );

  const componentName = selectedComponent.getName();
  const unsupportedComponents = ['Body'];

  // if it doesn't already exist, add it
  if (!visibilityCommandExists && !unsupportedComponents.includes(componentName)) {
    let newComponentTlb = [...defaultToolbar];
    const newTlbIcon = {
      attributes: { class: visibilityCommandIcon },
      command: visibilityCommandToAdd,
    };
    newComponentTlb.splice(defaultTlbIconLength - 1, 0, newTlbIcon);
    selectedComponent.set({
      toolbar: [...newComponentTlb],
    });
  }
}

function addCodeIcon(editor) {
  const selectedComponent = editor.getSelected();
  let defaultToolbar = selectedComponent.get('toolbar');

  // set your command and icon here
  const codeCommandToAdd = 'tlb-component-custom-code';
  const codeCommandIcon = 'fa fa-file-code-o';

  // check if this command already exists on this component toolbar
  const codeCommandExists = defaultToolbar.some((item) => item.command === codeCommandToAdd);

  const componentName = selectedComponent.getName();
  const unsupportedComponents = [
    'Body',
    'Custom HTML Code',
    'Collection Form',
    'Data Group',
    'Data Table',
    'Child Data Group',
    'Child Data Group (File)',
    'Child Data List',
    'Browser Storage Setter',
    'Calendar',
    'Time Slot',
    'Line Chart',
    'Area Chart',
    'Circular Gauge Chart',
    'Stripe: Buy Now',
    'Snipcart: Buy Now',
    'Snipcart: Cart',
    'Page List',
  ];
  // if it doesn't already exist, add it
  if (!codeCommandExists && !unsupportedComponents.includes(componentName)) {
    let newComponentTlb = [...defaultToolbar];
    const newTlbIcon = {
      attributes: { class: codeCommandIcon },
      command: codeCommandToAdd,
    };
    newComponentTlb.unshift(newTlbIcon);
    selectedComponent.set({
      toolbar: [...newComponentTlb],
    });
  }
}

export const buildBoxStyles = (property, theme) => {
  const shorthand = theme[property];
  const top = theme[`${property}Top`];
  const right = theme[`${property}Right`];
  const bottom = theme[`${property}Bottom`];
  const left = theme[`${property}Left`];

  if (shorthand) {
    return `${property.toLowerCase()}: ${shorthand};`;
  } else if (top || right || bottom || left) {
    return `${property.toLowerCase()}: ${top || '0'} ${right || '0'} ${bottom || '0'} ${
      left || '0'
    };`;
  }
  return '';
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const managePanelButtons = async (editor, isDisabled = true, isReadOnly) => {
  if (editor && editor.Panels) {
    if (isDisabled) {
      console.log('%c🚀 ~ Panel buttons disabled!', 'color:yellow');
      // Disable the canvas interaction
      toggleCanvasInteraction(editor);
      toggleLMInteraction();
      toggleStudioLoader();
    } else {
      await delay(3000); // Delay of 3 secs
      console.log('%c🚀 ~ Panel buttons enabled!', 'color:yellow');
      // Enable the canvas interaction
      toggleCanvasInteraction(editor, false);
      toggleLMInteraction(false);
      toggleStudioLoader(false);
    }
    const previewBtn = editor.Panels.getButton('options', 'preview');
    if (previewBtn) {
      previewBtn.set('disable', isDisabled);
    }
    const productionBtn = editor.Panels.getButton('options', 'build');
    if (productionBtn) {
      productionBtn.set('disable', isDisabled);
    }
    const saveBtn = editor.Panels.getButton('options', 'save-db');
    if (saveBtn) {
      saveBtn.set('disable', isDisabled || isReadOnly);
    }
    const clearBtn = editor.Panels.getButton('options', 'cmd-clear');
    if (clearBtn) {
      clearBtn.set('disable', isDisabled || isReadOnly);
    }
  }
};

// Disable/enable the canvas interactions
export const toggleCanvasInteraction = (editor, isDisabled = true) => {
  if (editor) {
    if (isDisabled) {
      editor.Canvas.getFrameEl().style.pointerEvents = 'none'; // Disable interactions
      editor.Canvas.getFrameEl().style.opacity = '0.7';
    } else {
      editor.Canvas.getFrameEl().style.pointerEvents = 'auto'; // Enable interactions
      editor.Canvas.getFrameEl().style.opacity = '1';
    }
  }
};

// Disable/enable the LM interactions
export const toggleLMInteraction = (isDisabled = true) => {
  const layerManagerEl = document.getElementById('layer-manager');
  if (layerManagerEl) {
    if (isDisabled) {
      layerManagerEl.style.opacity = '0.7';
      layerManagerEl.style.pointerEvents = 'none'; // Disable interactions
    } else {
      layerManagerEl.style.opacity = '1';
      layerManagerEl.style.pointerEvents = 'auto'; // Enable interactions
    }
  }
};

// Show/hide Builder Studio Loader
export const toggleStudioLoader = (isDisabled = true) => {
  if (isDisabled) {
    const loaderContainer = document.createElement('div');
    const loaderSpinner = document.createElement('div');
    const loaderImgLogo = document.createElement('img');
    const loaderContainerStyle = document.createElement('style');
    loaderContainerStyle.innerHTML = `
        #loader-container {
          width: 70px;
          height: 70px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        #loader-spinner {
          position: absolute;
          width: 100%;
          height: 100%;
          border: 12px solid #dcd7d7;
          border-top: 12px solid #1ba7ae;
          border-radius: 50%;
          animation: spin 2.5s linear infinite;
          z-index: 0;
        }
          
        #loader-logo {
          width: 50px;
          height: 50px;
          z-index: 1;
          background-image: url('${process.env.PUBLIC_URL}/favicon.png');
          background-size: cover;
          border-radius: 50%;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
          `;
    loaderContainer.id = 'loader-container';
    loaderSpinner.id = 'loader-spinner';
    loaderImgLogo.id = 'loader-logo';
    loaderImgLogo.alt = 'Logo';
    loaderImgLogo.src = `${process.env.PUBLIC_URL}/favicon.png`;
    loaderContainer.appendChild(loaderContainerStyle);
    loaderContainer.appendChild(loaderSpinner);
    loaderContainer.appendChild(loaderImgLogo);
    document.getElementById('gjs').appendChild(loaderContainer);
    loaderContainer.style.position = 'absolute';
    loaderContainer.style.top = '50%';
    loaderContainer.style.left = '48%';
    loaderContainer.style.zIndex = '1000'; // Ensure it appears above other elements
    loaderContainer.style.padding = '5px';
  } else {
    const loaderContainer = document.getElementById('loader-container');
    if (loaderContainer) {
      loaderContainer.style.display = 'none'; // To hide the loader
      loaderContainer.remove(); // To remove the loader
    }
  }
};
